import { SectionTitle } from '@/components/SectionTitle'
import { pageMaxWidth, pageXPadding, pageYPadding } from '@/config'
import { Testimonial, useTestimonials } from '@/features/public/testimonials'
import { Link } from 'react-router-dom'

export const ClientWords = () => {
  const testimonials = useTestimonials()
  if (testimonials.isLoading) {
    return (
      <div className="flex h-96 w-full items-center justify-center">
        <div className="size-[1em] animate-loader  rounded-[50%] text-[45px] text-[#D4AF37]"></div>
      </div>
    )
  }
  return (
    <section className={`${pageXPadding} ${pageYPadding}`}>
      <div className={`${pageMaxWidth} mx-auto flex flex-col gap-y-[24px]`}>
        <div className="flex flex-col gap-y-[12px] md:gap-y-[18px] lg:gap-y-[24px]">
          <div className="flex justify-center">
            <SectionTitle title={`Client's Words`} variant="tertiary" />
          </div>

          <p className="text-center font-nunito text-[12px] font-normal leading-[19.2px] text-[#333333] md:text-[14px] md:leading-[22.4px] lg:text-[14px] lg:leading-[25.6px]">
            {`See what our clients have to say about our transformative interior design services.Our clients trust us to create spaces that are not just beautiful, but functional and inspiring. From the initial concept to the final reveal, we're dedicated to bringing your vision to life.`}
          </p>
        </div>
        <div className="flex flex-col gap-y-[6px] md:flex-col-reverse">
          <div className="flex flex-col gap-y-[12px] md:flex-row md:flex-wrap md:gap-[22px] lg:gap-[26px]">
            {testimonials.data?.map(
              (testimonial, index) =>
                index < 4 && (
                  <div
                    className="w-full md:w-[calc(50%-11px)] lg:w-[calc(50%-13px)]"
                    key={index}
                  >
                    <TestimonialCard {...testimonial} />
                  </div>
                )
            )}
          </div>
          <div className="flex justify-end ">
            <Link
              to={'testimonials'}
              className="font-nunito text-[10px] font-normal leading-[12.8px] text-[#333333]  md:text-[12px] md:leading-[17.6px] lg:text-[14px] lg:leading-[22.4px] "
            >
              View More...
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}

const TestimonialCard = ({ profilePhoto, review, name, role }: Testimonial) => {
  return (
    <div className="flex flex-col gap-y-[12px] rounded-[24px] border-[1.5px] border-[#D4AF37] bg-gradient-to-b from-[#F5F5F5] to-[#D9C7B0] p-[20px] md:gap-y-[18px] lg:gap-y-[24px]">
      <div className="flex gap-x-[8px]">
        <img
          src={profilePhoto.url}
          className="size-[30px] rounded-[50%] object-cover md:size-[40px] lg:size-[50px]"
        />
        <div className="flex flex-col font-nunito text-[#333333]">
          <h2 className="text-[12px] font-bold leading-[19.2px] md:text-[14px] md:leading-[22.4px] lg:text-[16px] lg:leading-[25.6px]">
            {name}
          </h2>
          <p className="text-[9px] font-normal leading-[14.4px] md:text-[10.5px] md:leading-[16.9px] lg:text-[12px] lg:leading-[19.2px]">
            {role}
          </p>
        </div>
      </div>
      <p className="font-nunito text-[12px] font-normal leading-[19.2px] text-[#333333] md:text-[14px] md:leading-[22.4px] lg:text-[16px] lg:leading-[25.6px]">
        {review}
      </p>
    </div>
  )
}
